import {extendsAPIServices} from "./APIServices";
import getEnv from "../../helpers/common/getEnv";
import {GET, POST} from "../../constants/HTTPConstants";

const baseAdminAPI = getEnv('baseAdminAPI');
const api = extendsAPIServices(baseAdminAPI);

const basePaymentApi = getEnv('basePaymentAPI');
const paymentAPI = extendsAPIServices(basePaymentApi)

export const _getListCoupons = ({page = 1, limit}) => {
    return api.makeAuthRequest({
        method: GET,
        url: `/coupons?page=${page}&limit=${limit}`
    });
};

export const _createNewCoupon = ({description, code, duration, duration_in_months, amount_off, percent_off, max_redemptions, expired_at, plans}) => {
    return api.makeAuthRequest({
        method: POST,
        url: `/coupons`,
        data: {
            description,
            code,
            duration,
            duration_in_months,
            amount_off,
            percent_off,
            max_redemptions,
            expired_at,
            plans
        }
    });
};

export const _updateCouponStatus = (couponId, status) => {
    return api.makeAuthRequest({
        method: POST,
        url: `/coupons/${couponId}/status`,
        data: {
            status
        }
    })
};

export const _getUsersUseCoupon = (coupon) => {
    return paymentAPI.makeAuthRequest({
        method: GET,
        url: '/coupon/users/total',
        params: {
            code: coupon,
        }
    })
}


// WEBPACK FOOTER //
// ./src/services/apis/AdminCouponServices.js